import { type EmbedIFrameComponent } from '../embed-component'

export interface EmbedStrategy {
  embed (): Promise<void>
  destroy?(): void
  show (): void
  hide (): void
}

export interface WithIFrame {
  iFrameComponent: EmbedIFrameComponent
}

export function isWithIFrame (obj: any): obj is WithIFrame {
  return obj.iFrameComponent != null
}
